import React, { Fragment } from 'react'
import CSSModules from 'react-css-modules'
import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'

import styles from './styles.scss'

const WaitingPage = () =>
    <Fragment>
        <p>Importing...</p>
        <ProgressBar />
    </Fragment>

export default CSSModules(WaitingPage, styles)
